export default "__VITE_ASSET__BRjNJ7H___"